import React, { useState, useEffect } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, FormGroup } from "reactstrap";
import { fetchDocumentDescriptors } from "./Axios";
import Select from "react-select";

const StepForm = ({ isOpen, onClose, step = null }) => {
  const [stepData, setStepData] = useState({
    name: "",
    description: "",
    required: false,
    kind: "",
    custom_fields: [],
    locked: false,
  });

  const [documentDescriptors, setDocumentDescriptors] = useState([]);
  const [selectedDocuments, setSelectedDocuments] = useState([]);

  useEffect(() => {
    if (isOpen) {
      fetchDocumentDescriptors().then(setDocumentDescriptors);
    }
  }, [isOpen]);

  useEffect(() => {
    if (step) {
      setStepData({
        name: step.name || "",
        description: step.description || "",
        required: step.required || false,
        kind: step.kind || "",
        locked: step.locked || false,
        custom_fields: step.custom_fields?.map(field => ({
          id: field.id || null,
          name: field.name || "",
          label: field.label || field.name || "",
          field_type: field.field_type || "text",
          description: field.description || "",
          tempId: field.id || `new-${Math.random()}`,
        })) || [],
      });

      if (step.document_descriptors) {
        setSelectedDocuments(step.document_descriptors.map(d => d.id));
      }
    }
  }, [step]);

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg">
      <ModalHeader toggle={onClose}>{step ? "Ver Step" : "Agregar Step"}</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label for="name">Nombre</Label>
          <Input id="name" type="text" value={stepData.name} readOnly />
        </FormGroup>

        <FormGroup>
          <Label for="description">Descripción</Label>
          <Input id="description" type="textarea" value={stepData.description} readOnly />
        </FormGroup>

        <FormGroup>
          <Label for="kind">Tipo de Step</Label>
          <Input id="kind" type="select" value={stepData.kind} disabled>
            <option value="">Selecciona...</option>
            <option value="interview">Entrevista</option>
            <option value="document_upload">Subida de Documento</option>
            <option value="document_request">Solicitud de Documento</option>
          </Input>
        </FormGroup>

        {stepData.kind === "document_upload" && (
          <FormGroup>
            <Label for="documentDescriptors">Documentos Requeridos</Label>
            <Select
              id="documentDescriptors"
              isMulti
              options={documentDescriptors.map(doc => ({ value: doc.id, label: doc.name }))}
              value={documentDescriptors
                .filter(doc => selectedDocuments.includes(doc.id))
                .map(doc => ({ value: doc.id, label: doc.name }))}
              isDisabled
            />
          </FormGroup>
        )}

        <FormGroup check>
          <Label check>
            <Input type="checkbox" checked={stepData.required} disabled />
            ¿Es obligatorio?
          </Label>
        </FormGroup>

        <hr />
        <h5>Campos Personalizados</h5>

        {stepData.custom_fields.map((field) => (
          <div key={field.tempId} className="mb-3">
            <FormGroup>
              <Label>Nombre del Campo</Label>
              <Input type="text" value={field.name} readOnly />
            </FormGroup>
            <FormGroup>
              <Label>Tipo de Campo</Label>
              <Input type="select" value={field.field_type} disabled>
                <option value="text">Texto</option>
                <option value="date">Fecha</option>
                <option value="checkbox">Checkbox</option>
                <option value="textarea">Área de Texto</option>
              </Input>
            </FormGroup>
            <FormGroup>
              <Label>Descripción</Label>
              <Input type="textarea" value={field.description} readOnly />
            </FormGroup>
            <hr />
          </div>
        ))}
      </ModalBody>

      <ModalFooter>
        <Button color="danger" onClick={onClose}>Cerrar</Button>
      </ModalFooter>
    </Modal>
  );
};

export default StepForm;
